import { useMutation } from "react-query";
import downloadInventoryHistoryCSV from "../services/downloadInventoryHistoryCSV";

function useDownloadInventoryHistoryCSV() {
  return useMutation(
    ["download-inventory-history-csv"],
    downloadInventoryHistoryCSV
  );
}

export default useDownloadInventoryHistoryCSV;
